import { Country } from '@/types';
import { Core, COUNTRIES } from '../Core';

class Countries extends Core {
  getCountries = async () => this.get<Country[]>(COUNTRIES());
}

export const countries = new Countries();
